// This icon file is generated automatically.
var PLayoutOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.75.75H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zM1.87 1.88H4v10.25H1.87V1.87zm10.25 10.25H5V5h7.13v7.13zM5 4V1.87h7.13V4H5z", "fill-rule": "nonzero" } }] }, "name": "p-layout", "theme": "outlined" };
export default PLayoutOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PLayoutOutlined.js
// module id = 3481
// module chunks = 0